/* Punartha — scroll reveal. Adds .is-in to [data-reveal] on view. No deps, no globals. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function reveal(scope) {
    var nodes = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!nodes.length || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          if (el.dataset.revealDelay) { el.style.setProperty('--reveal-delay', el.dataset.revealDelay + 'ms'); }
          el.classList.add('is-in');
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else { reveal(); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
